import _ from 'lodash';
import DateHelper from './DateHelper';
export default class PredefRemarkHelper {
    static setSpecRemark(predefObject, func, prtype) {
        if (predefObject == undefined) {
            return null;
        }
        const iqValue = predefObject.iq;
        let returnObject = null;
        let prefRemarkLabel = null;
        let predefinedType = prtype ?? null;
        let showvalue = null;
        let predefinedRemark = predefObject;
        if (iqValue == undefined) {
            switch (predefinedType) {
                case window.constants.PDT_ALTBRINELOCATION: {
                    // in =>  {bad.kooi.laag.aantal},
                    // resultaat wordt: {bad.kooi.laag.aantal} // voorlopig dus niets
                    prefRemarkLabel = func('prod_pekellocatie2', {
                        ns: 'production'
                    });
                    const remarkParts = this.remarkObject.split('.');
                    if (remarkParts.length === 4) {
                        predefinedRemark = {
                            Bad: remarkParts[0],
                            Kooi: remarkParts[1],
                            Laag: remarkParts[2],
                            Aantal: remarkParts[3]
                        };
                    }
                    predefinedType = window.constants.PDT_ALTBRINELOCATION;
                    showvalue = predefObject;
                    break;
                }
                default:
                    return null;
            }
        } else {
            switch (iqValue) {
                case window.constants.ADATA_IQ_PHVP: {
                    prefRemarkLabel = func('an_verzuringstijd', {
                        ns: 'analytics'
                    });
                    predefinedType = window.constants.PDT_VERZURINGSDUUR;
                    showvalue = predefObject.regtijd;
                    break;
                }
            }
        }
        returnObject = {
            label: prefRemarkLabel,
            remark: predefinedRemark,
            type: predefinedType,
            showvalue: showvalue
        };
        return returnObject;
    }
    static initiateSpecRemark(remarkObject, func) {
        const o = remarkObject;
        if (o == undefined) {
            return null;
        }
        const iqValue = o.iq;
        let returnObject = null;
        let prefRemarkLabel = null;
        let predefinedRemark = null;
        let predefinedType = null;
        let showvalue = null;
        if (iqValue == undefined) {
            const prType = o.predefinedType;
            switch (prType) {
                case window.constants.PDT_ALTBRINELOCATION: {
                    // in =>  {bad.kooi.laag.aantal},
                    // resultaat wordt: {bad.kooi.laag.aantal} // voorlopig dus niets
                    prefRemarkLabel = func('prod_pekellocatie2', {
                        ns: 'production'
                    });
                    const remarkParts = this.remarkObject.split('.');
                    if (remarkParts.length === 4) {
                        predefinedRemark = {
                            Bad: remarkParts[0],
                            Kooi: remarkParts[1],
                            Laag: remarkParts[2],
                            Aantal: remarkParts[3]
                        };
                    }
                    predefinedType = window.constants.PDT_ALTBRINELOCATION;
                    showvalue = remarkObject;
                    break;
                }
                default:
                    return null;
            }
        } else {
            switch (iqValue) {
                case window.constants.ADATA_IQ_PHVP: {
                    // in => iq: this.idIQphvp, zuurselTijd: zuurseltijd,inpekelTijd: inpekeltijd,
                    // resultaat wordt: iq=40; calctijd=5:15; regtijd=5:00
                    let regtijd = '--:--';
                    let calculated = '??:??';
                    const calctijd = DateHelper.dateDiffHoursAndMinutes(
                        o.inpekelTijd,
                        o.zuurselTijd
                    );
                    if (calctijd != undefined) {
                        let h = calctijd.hours.toString();
                        let m = calctijd.minutes.toString();
                        if (h.length == 1) h = '0' + h;
                        if (m.length == 1) m = '0' + m;
                        calculated = h + ':' + m;
                        if (calctijd.hours > 0 && calctijd.hours < 24) {
                            regtijd = calculated;
                        }
                    }

                    prefRemarkLabel = func('an_verzuringstijd', {
                        ns: 'analytics'
                    });
                    predefinedRemark = {
                        iq: iqValue,
                        calctijd: calculated,
                        regtijd: regtijd
                    };
                    predefinedType = window.constants.PDT_VERZURINGSDUUR;
                    showvalue = regtijd;
                    break;
                }
            }
        }
        returnObject = {
            label: prefRemarkLabel,
            remark: predefinedRemark,
            type: predefinedType,
            showvalue: showvalue
        };
        return returnObject;
    }
}
